// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3lc0Y","imageUploader":"EGiftCard_imageUploader__1IUa5"};